import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-a9071ac0")

_pushScopeId("data-v-a9071ac0")
const _hoisted_1 = /*#__PURE__*/_createTextVNode("単元を編集")
const _hoisted_2 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_3 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_4 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_5 = { class: "w-3/4 mx-auto mb-6" }
const _hoisted_6 = { class: "flex flex-row" }
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 単元を削除 ")
const _hoisted_8 = /*#__PURE__*/_createTextVNode(" 単元を編集 ")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_m_text_field = _resolveComponent("m-text-field")
  const _component_m_button = _resolveComponent("m-button")
  const _component_MBaseModal = _resolveComponent("MBaseModal")

  return (_openBlock(), _createBlock(_component_MBaseModal, { onClose: _ctx.close }, {
    title: _withId(() => [
      _hoisted_1
    ]),
    body: _withId(() => [
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_m_text_field, {
          label: "単元名",
          name: "unit-name",
          type: "text",
          placeholder: "単元名を記入してください。",
          value: _ctx.unitName,
          onInput: _cache[1] || (_cache[1] = ($event: any) => (_ctx.unitName = $event))
        }, null, 8, ["value"])
      ]),
      _createVNode("div", _hoisted_3, [
        _createVNode(_component_m_text_field, {
          label: "グラフのタイトル",
          name: "graph-title",
          type: "text",
          placeholder: "グラフのタイトルを記入してください。",
          value: _ctx.graphTitle,
          onInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.graphTitle = $event))
        }, null, 8, ["value"])
      ]),
      _createVNode("div", _hoisted_4, [
        _createVNode(_component_m_text_field, {
          label: "2段目のタイトル",
          name: "second-row-title",
          type: "text",
          placeholder: "2段目のタイトルを記入してください。",
          value: _ctx.secondRowTitle,
          onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.secondRowTitle = $event))
        }, null, 8, ["value"])
      ]),
      _createVNode("div", _hoisted_5, [
        _createVNode(_component_m_text_field, {
          label: "3段目のタイトル",
          name: "third-row-title",
          type: "text",
          placeholder: "3段目のタイトルを記入してください。",
          value: _ctx.thirdRowTitle,
          onInput: _cache[4] || (_cache[4] = ($event: any) => (_ctx.thirdRowTitle = $event))
        }, null, 8, ["value"])
      ])
    ]),
    footer: _withId(() => [
      _createVNode("div", _hoisted_6, [
        _createVNode(_component_m_button, {
          class: "mr-4",
          color: "red-400",
          "hover-color": "red-500",
          outline: "",
          onClick: _ctx.deleteUnit
        }, {
          default: _withId(() => [
            _hoisted_7
          ]),
          _: 1
        }, 8, ["onClick"]),
        _createVNode(_component_m_button, {
          color: "primary-500",
          "hover-color": "primary-600",
          disabled: !_ctx.validData,
          onClick: _ctx.updateUnit
        }, {
          default: _withId(() => [
            _hoisted_8
          ]),
          _: 1
        }, 8, ["disabled", "onClick"])
      ])
    ]),
    _: 1
  }, 8, ["onClose"]))
})